// extracted by mini-css-extract-plugin
module.exports = {"mainCard":"style_mainCard__3PdcR","cardHeader":"style_cardHeader__ZZWQV"};